import _ from 'lodash';
// import { access } from 'fs';

module.exports = {
  donorsIncluded: function (donorCategories, include_categories) {
    if (donorCategories.length === 0) {
      console.log("returning null array");
      return [];
    }

    //let donorsGrouped = _.filter(donorCategories, {id: include_categories});
    let donorsGrouped = _.filter(donorCategories, v => _.includes(include_categories, v.id) && v.donors.length>0);

    //restore if required for use elsewhere
    // donorsGrouped = _.map(donorsGrouped, function (v) {
    //   return { id: v.id, name: v.name, rank: v.rank, subheader: v.subheader, donors: v.donors, parent_category: v.parent_category, description: v.description }
    // });

    //depricated
    // let donorsGrouped = [];
    // _.forEach(donorCategories, (category) => {
    //   if (category.donors.length > 0) {
    //     _.forEach(include_categories, (icat) => {
    //       if (icat === category.id) {
    //         let pushGroup = { id: category.id, name: category.name, rank: category.rank, subheader: category.subheader, donors: category.donors, parent_category: category.parent_category, description: category.description };
    //         donorsGrouped.push(pushGroup);
    //       }
    //     });
    //   }
    // });
    donorsGrouped = _.orderBy(donorsGrouped, 'rank', 'asc');
    return donorsGrouped
  },

  searchDonorList: function(content, donors, searchStr) {
    let donorListsModules = _.filter(content.dm_active, {display_module_type: "Donor List"});
    let groupedDonorLists = [];

		if (donorListsModules.length > 0) {
			donorListsModules.forEach((dm) => {
				let donorListGrouped = module.exports.donorsIncluded(donors.donorCategories, dm.contents.include_categories);
				groupedDonorLists.push({
					module: dm,
					group: donorListGrouped
				});
			})
    }

    let foundGroups = [];
    groupedDonorLists.forEach((module, i) => {
      if (module.group.length > 0) {
        module.group.some((group, j) => {
          let match = 0;
          group.donors.forEach((donor, k) => {
            if (donor.name.toLowerCase().indexOf(searchStr) !== -1) {
              match++;
              return true;
            }
          })

          if (match > 0) {
            foundGroups.push(group);
            return true;
          }

          return false;
        });

        groupedDonorLists[i].group = foundGroups;
      }
    })

    return groupedDonorLists;
  },

  searchInDonorLists: function(content, donors, searchStr) {
    let foundDonors = [];
    let donorLists = [];
    let foundDonorsIds = [];

    for (let i = 0; i < donors.donorCategories.length; i++) {
      if (donors.donorCategories[i].donors && donors.donorCategories[i].donors.length > 0) {
        let categoryDonors  = donors.donorCategories[i].donors;
        let match = _.filter(categoryDonors, donor => {
          let name = donor.name.toLowerCase();
          let isIncluded = name.includes(searchStr);
          if (isIncluded) {
            foundDonorsIds.push(donor.id);
          }
          return isIncluded;
        });
        if (match && match.length > 0) {
          donorLists.push(donors.donorCategories[i].id);
        }
        foundDonors = foundDonors.concat(match);
      }
    }

    let results = {
      donorLists: donorLists,
      foundDonors: foundDonors,
      foundDonorsIds: foundDonorsIds
    }

    return results;
  },

  searchInFolderDonorLists: function(folders, donors, searchStr, rootFolderId = null) {
    // let foundDonors = [];
    let foundFolders = [];
    let foundDonorsIds = [];
    let allDonors = [];

    for (let x = 0; x < donors.donorCategories.length; x++) {
      if (donors.donorCategories[x].donors && donors.donorCategories[x].donors.length > 0) {
        allDonors = allDonors.concat(donors.donorCategories[x].donors);
      }
    }

    let match = _.filter(allDonors, donor => {
      let name = donor.name.toLowerCase();
      let isIncluded = name.includes(searchStr);
      let added = false;
      if (isIncluded && (foundDonorsIds.indexOf(donor.id) === -1)) {
        if (rootFolderId !== null) {
          if (module.exports.checkIfDonorIsChildOf(donor.folder_module.folder, rootFolderId, folders)) {
            foundDonorsIds.push(donor.id);
            if (donor.folder_module) {
              if (foundFolders.indexOf(donor.folder_module.folder) === -1) {
                foundFolders.push(donor.folder_module.folder);
              }
            }
            added = true;
          }
        } else {
          foundDonorsIds.push(donor.id);
          if (donor.folder_module) {
            if (foundFolders.indexOf(donor.folder_module.folder) === -1) {
              foundFolders.push(donor.folder_module.folder);
            }
          }
          added = true;
        }
      }
      return added;
    });

    let results = {
      foundFolders: foundFolders,
      foundDonors: match,
      foundDonorsIds: foundDonorsIds
    }

    return results;
  },

  checkIfDonorIsChildOf: function(childFolderId, parentFolderId, folders) {
    const childFolder = folders.find(f => f.id === childFolderId);
    if (!childFolder) {
      return false;
    }
    if (childFolder.parent_category === parentFolderId) {
      return true;
    }
    return module.exports.checkIfDonorIsChildOf(childFolder.parent_category, parentFolderId, folders);
  },

  getDonorsFromFolder: function(donors, folderModules, folder) {
    let allDonors = [];
    for (let i = 0; i < donors.donorCategories.length; i++) {
      allDonors = allDonors.concat(donors.donorCategories[i].donors);
    }
    
    let filteredDonors = folderModules
    .filter(fm => fm.folder === folder && fm.model === "donor")
    .reduce((acc, cur) => {
      let donor = allDonors.find(dn => dn.id === cur.module_id && cur.model === "donor");
      if (donor) {
        donor.folder_module = cur;
        acc = acc.concat(donor);
      }

      return acc;
    }, []);

    return filteredDonors;
  }
}




// WEBPACK FOOTER //
// ./src/utils/donorHelpers.js